import {inject, Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {Seller} from "../models/seller";
import {DealApiService} from "../generated-sources/api/deal";

@Injectable({
    providedIn: "root"
})
export class SellerService {
    private readonly dealApiService = inject(DealApiService)

    constructor( ) {
    }

    getSellers(): Observable<Seller[]> {
        return this.dealApiService.getSellers();
    }

    getSeller(id: number): Observable<Seller> {
        return this.dealApiService.getSeller(id);
    }

    saveSeller(seller: Seller): Observable<Seller> {
        return seller.id ? this.dealApiService.updateSeller(seller.id, seller) : this.dealApiService.createSeller(seller);
    }
}
